import React, { useRef } from 'react';
import { Slide } from 'react-slideshow-image';
import ReviewItem from './ReviewItem';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const MethodsExample = (props) => {
  const slideRef = useRef();

  const properties = {
    autoplay: false,
    arrows: false,
    duration: 5000,
    transitionDuration: 400,
    infinite: true,
  };

  const back = () => {
    slideRef.current.goBack();
  };

  const next = () => {
    slideRef.current.goNext();
  };

  // const goto = ({ target }) => {
  //   slideRef.current.goTo(parseInt(target.value, 10));
  // };

  const { reviewData } = props;

  const callBackClickItem = (data) => {
    if (props.callBackClickItem) {
      props.callBackClickItem(data);
    }
  };

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <Slide ref={slideRef} {...properties}>
          {reviewData.map((data, index) => {
            return (
              <div style={{ width: '70%', backgroundColor: 'gold', margin: '0 auto' }} key={`methodex-outer-div-${index}`}>
                <div style={{ display: 'flex', justifyContent: 'center' }} key={`methodex-inner-div-${index}`}>
                  <ReviewItem data={data} callBackClickItem={callBackClickItem} />
                </div>
              </div>
            );
          })}
        </Slide>
        <div
          onClick={back}
          style={{
            left: '10px',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.15)',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <ArrowBackIosIcon style={{ color: '#fff' }} />
        </div>
        <div
          onClick={next}
          style={{
            right: '10px',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.15)',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <ArrowForwardIosIcon style={{ color: '#fff' }} />
        </div>
      </div>

      {/* <div className="autoplay-buttons">
        <button type="button" onClick={back}>
          Back
        </button>
        <button type="button" onClick={next}>
          Next
        </button>
        <select onChange={goto}>
          <option>--Select--</option>
          <option value="0">First</option>
          <option value="1">Second</option>
          <option value="2">Third</option>
        </select>
      </div> */}
    </div>
  );
};

export default MethodsExample;
